var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImageTile',{attrs:{"clickFunction":_vm.clickFunction,"preline":_vm.getCategoryName(_vm.recipe),"headline":_vm.recipe.title,"imgUrl":_vm.recipe.thumbnailImage}})}
var staticRenderFns = []

export { render, staticRenderFns }